<template>
  <!-- Sidebar -->
  <ul class="navbar-nav bg-gradient-danger sidebar sidebar-dark accordion" id="accordionSidebar" :class="{toggled: toggleStatus}">
    <!-- Sidebar - Brand
      <a class="sidebar-brand d-flex align-items-center justify-content-center" href="index.html">
        <div class="sidebar-brand-icon rotate-n-15">
          <i class="fas fa-laugh-wink"></i>
        </div>
        <div class="sidebar-brand-text mx-3">{{appName}}</div>
      </a>
    -->
    <router-link
      :to="{ name: user ? 'dashboard' : 'login' }"
      class="sidebar-brand d-flex align-items-center justify-content-center"
    >
      <div class="sidebar-brand-icon">
        <img src="images/candado_steel_blanco.svg" width="30" />
      </div>
      <div class="sidebar-brand-text mx-3">Clientes</div>
    </router-link>

    <!-- Divider -->
    <hr class="sidebar-divider my-0" />

    <!-- Nav Item - Dashboard -->
    <router-link :to="{ name: 'dashboard' }" tag="li" class="nav-item" active-class="active">
      <a class="nav-link">
        <fa icon="tachometer-alt" fixed-width />
        <span> Resumen</span>
      </a>
    </router-link>

    <!-- Divider -->
    <hr class="sidebar-divider" />

    <!-- Nav Item - Internet -->
    <router-link :to="{ name: 'internet' }" tag="li" class="nav-item" active-class="active">
      <a class="nav-link">
        <fa icon="globe-americas" fixed-width />
        <span> Internet</span>
      </a>
    </router-link>

    <!-- Nav Item - Monitoreo -->
    <router-link :to="{ name: 'monitoreo' }" tag="li" class="nav-item" active-class="active">
      <a class="nav-link">
        <fa icon="eye" fixed-width />
        <span> Monitoreo</span>
      </a>
    </router-link>

    <!-- Nav Item - Televisión -->
    <router-link :to="{ name: 'television' }" tag="li" class="nav-item" active-class="active">
      <a class="nav-link">
        <fa icon="tv" fixed-width />
        <span> Televisión</span>
      </a>
    </router-link>

    <!-- Nav Item - Facturacion -->
    <router-link :to="{ name: 'facturacion' }" tag="li" class="nav-item" active-class="active">
      <a class="nav-link">
        <fa icon="file-invoice-dollar" fixed-width />
        <span> Facturación</span>
      </a>
    </router-link>

    <!-- Nav Item - Pagar -->
    <!-- <router-link :to="{ name: 'pagar' }" tag="li" class="nav-item" active-class="active">
      <a class="nav-link">
        <fa icon="dollar-sign" fixed-width />
        <span> Pagar</span>
      </a>
    </router-link> -->

    
  </ul>
  <!-- End of Sidebar -->
</template>

<script>
import { mapGetters } from 'vuex'
const appName = process.env.VUE_APP_TITLE

export default {
  name: 'Sidebar',
  data: () => ({
    arrow: true,
    appName: appName
  }),

  computed: {
    ...mapGetters({
      user: 'auth/user',
      toggleStatus: 'layout/toggleStatus'
    })
  },

  methods: {
    sidebarToggle () {
      this.arrow = !this.arrow
      $('body').toggleClass('sidebar-toggled')
      $('.sidebar').toggleClass('toggled')
      if ($('.sidebar').hasClass('toggled')) {
        $('.sidebar .collapse').collapse('hide')
      }
    },
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    },
    hasRole (roles) {
      if (this.$store.getters['auth/check']) {
        return this.$store.getters['auth/hasRole'](roles)
      }
      return false
    }
  }
}
</script>

<style scoped>
.profile-photo {
  width: 2rem;
  height: 2rem;
  margin: -0.375rem 0;
}
</style>
